/**
 * @generated SignedSource<<cdad03dfb3b463d9d8dd1b88570621b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type systemFilters_navigationAppsSidebarFilters_SystemFiltersSection$data = {
  readonly systemFilters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly filterId: string;
        readonly " $fragmentSpreads": FragmentRefs<"filterItem_navigationAppsSidebarCommon">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection";
};
export type systemFilters_navigationAppsSidebarFilters_SystemFiltersSection$key = {
  readonly " $data"?: systemFilters_navigationAppsSidebarFilters_SystemFiltersSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"systemFilters_navigationAppsSidebarFilters_SystemFiltersSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Literal",
          "name": "isFavourite",
          "value": false
        }
      ],
      "concreteType": "JiraSystemFilterConnection",
      "kind": "LinkedField",
      "name": "systemFilters",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSystemFilterEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSystemFilter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "filterId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "filterItem_navigationAppsSidebarCommon"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "3a63b8dc9c67f2a7294ca62240142cfa";

export default node;
